import React from 'react'

function EmployeeName({row , i}) {
  return (
    <>{row?.employee?.employeeName}</>
  )
}

export default EmployeeName